import axiosInstance from '../../../utils/axiosConfig'
import { mobileBackendUrl } from '../../../env'
import { InvestmentTransactionList, TaxLiabilityDataResponseType } from '../types/investmentApi.types'

export const fetchTaxLiability = async (isin: string, temporaryFamilyAccessToken?: string) => {
  const tokenQuery = temporaryFamilyAccessToken
    ? `?temporaryFamilyAccessToken=${encodeURIComponent(temporaryFamilyAccessToken)}`
    : ''

  return axiosInstance.get<TaxLiabilityDataResponseType>(
    `${mobileBackendUrl}/v1/portfolio/user/${isin}/tax-liability${tokenQuery}`
  )
}

export const fetchInvsetmentTransactions = async (
  isin: string,
  pageSize: number,
  timestamp: number,
  temporaryFamilyAccessToken?: string
) => {
  const tokenQuery = temporaryFamilyAccessToken
    ? `&temporaryFamilyAccessToken=${encodeURIComponent(temporaryFamilyAccessToken)}`
    : ''

  return axiosInstance.get<InvestmentTransactionList>(
    `${mobileBackendUrl}/v1/portfolio/user/${isin}/txns?pageSize=${pageSize}&timestamp=${timestamp}${tokenQuery}`
  )
}

